import BaseEnumType from "../../common/base-enum-type";

const DriveStartType = Object.freeze({
    Kickoff: new BaseEnumType("KO", "Kickoff")
});

export default DriveStartType;
